module.exports = __webpack_public_path__ + "static/media/logo1.23762887.png";